function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 18"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.54 0c.1 0 .2 0 .3.1.2.19.2.39.1.58L.97 8.97l6.87 8.29c.2.19.1.48-.1.68-.2.1-.4.1-.6-.1L.07 9.26c-.1-.19-.1-.39 0-.58L7.14.1c.1 0 .2-.1.4-.1",
    style: {
      strokeWidth: 0
    }
  }));
};
export default SvgChevronLeft;